import catalogue from './catalogue.json';

/** Static template definition: background asset, editable fields and their layout. */
export class SignageTemplate {
  constructor(definition) {
    if (!definition.id || !definition.category || !definition.background || !Array.isArray(definition.fields) || !definition.fields.length) throw new Error('Invalid template definition.');
    const ids = new Set();
    definition.fields.forEach((field) => {
      if (!field.id || ids.has(field.id)) throw new Error(`Duplicate or missing field in ${definition.id}`);
      ids.add(field.id);
      ['landscape', 'portrait', 'banner'].forEach((format) => {
        const box = field.positions[format];
        if (!box || box.x < 0 || box.y < 0 || box.width <= 0 || box.height <= 0 || box.x + box.width > 1.001 || box.y + box.height > 1.001) throw new Error(`Invalid field position: ${definition.id}/${field.id}/${format}`);
      });
    });
    this.id = definition.id; this.category = definition.category; this.name = definition.name;
    this.description = definition.description; this.background = definition.background;
    this.photoBackground = definition.photoBackground; this.backgroundColor = definition.backgroundColor;
    this.visualStyle = definition.visualStyle; this.accentColor = definition.accentColor;
    this.fields = Object.freeze(definition.fields.map((field) => Object.freeze({ ...field })));
    Object.freeze(this);
  }
  defaultValues() { return Object.fromEntries(this.fields.map((field) => [field.id, field.defaultValue || ''])); }
  validate(values) { return this.fields.filter((field) => (field.required && !String(values[field.id] || '').trim()) || String(values[field.id] || '').length > field.maxLength).map((field) => field.label); }
  title(values) { return String(values.title || this.name).trim(); }
}
export const TEMPLATE_CATEGORIES = Object.freeze(catalogue.categories);
export const SIGNAGE_TEMPLATES = Object.freeze(catalogue.templates.map((definition) => new SignageTemplate(definition)));
export function templatesForCategory(category) { return SIGNAGE_TEMPLATES.filter((template) => template.category === category); }
export function getSignageTemplate(id) { return SIGNAGE_TEMPLATES.find((template) => template.id === id); }
